import { FunctionComponent, useMemo } from 'react'
import { Text } from '@conexasaude/conexa-hero'
import { useAuthContext } from '@/modules/Auth/contexts/AuthContext'
import { HeroWrapper } from '@/styles/rebranded/HeroWrapper'
import { ContentLayout } from './ContentLayout'
import { ContentLayoutProps } from './ContentLayout/types'
import { useStyles } from './styles'

const CustomLayout: FunctionComponent<ContentLayoutProps> = ({
  children,
  ...props
}) => {
  const styles = useStyles()
  const { user } = useAuthContext()
  const patientInfomation = useMemo(() => {
    return `ID: ${user?.patientId} | Clínica: ${user?.clinic?.name}`
  }, [user?.patientId, user?.clinic?.name])

  return (
    <HeroWrapper>
      <ContentLayout
        layoutFooterProps={{
          copyContent: user ? (
            <Text variant="microCopy" css={styles.userInfoText}>
              {patientInfomation}
            </Text>
          ) : null,
        }}
        {...props}
      >
        {children}
      </ContentLayout>
    </HeroWrapper>
  )
}

export default CustomLayout
